import type { DeviceType, VersionInfo } from '@rapoo/device-sdk'

/** 保留 SDK 芯片顺序，逐项回退；不把其他设备或接收器的版本混入弹窗。 */
export function formatLatestFirmwareVersion(
  versions: readonly VersionInfo[] | undefined,
  deviceType: DeviceType,
): string {
  return (
    versions
      ?.filter((item) => item.deviceType === deviceType)
      .map((item) => item.onlineVersion?.trim() || item.version)
      .filter(Boolean)
      .join(' - ') || '-'
  )
}
